var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Form from "@irati/ui/src/Form";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import { H2 } from "@irati/ui/src/Headings";
import TeamName from "@irati-web/fields/team/PublicName";
import Loading from "@irati/ui/src/Loading";
import adminTracking from "@irati-tracking/admin";
import teamService from "@irati/identity/services/teams";
import authentication from "@irati/auth";
import { StyledDiv, StyledH4, LeftAlign, MarginRightButton } from "./styled";
var CreateTeamName = /** @class */ (function (_super) {
    __extends(CreateTeamName, _super);
    function CreateTeamName() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            name: "",
            submit: null
        };
        _this.handleChange = function (name) {
            _this.setState({ name: name });
        };
        _this.handleNameSubmit = function () {
            var onSubmit = _this.props.onSubmit;
            var public_name = _this.state.name.trim();
            var submit = teamService.create({ tenantId: authentication.userTenant().uuid, data: { public_name: public_name } }, true, true).then(function (team) {
                return onSubmit(team);
            });
            _this.setState({ submit: submit });
            adminTracking.createTeam(public_name);
            return submit;
        };
        return _this;
    }
    CreateTeamName.prototype.render = function () {
        var _a = this.state, submit = _a.submit, name = _a.name;
        var _b = this.props, formatMessage = _b.formatMessage, onBack = _b.onBack;
        return (React.createElement(StyledDiv, null,
            React.createElement(H2, null,
                React.createElement(FormattedMessage, { id: "admin.components.createTeamName.headerTwo" })),
            React.createElement(StyledH4, null,
                React.createElement(FormattedMessage, { id: "admin.components.createTeamName.headerFour" })),
            React.createElement(Form, { form: "create-team" },
                React.createElement(LeftAlign, null,
                    React.createElement(TeamName, { value: name, onChange: this.handleChange })),
                onBack && (React.createElement(MarginRightButton, { large: true, onClick: onBack },
                    React.createElement(FormattedMessage, { id: "admin.components.createTeamName.button.back" }))),
                React.createElement(ValidationButton, { primary: true, load: submit, loading: formatMessage({ id: "admin.components.createTeamName.validationButton.loading" }), onClick: this.handleNameSubmit },
                    React.createElement(FormattedMessage, { id: "admin.components.createTeamName.validationButton.continue" }))),
            React.createElement(Loading, { load: submit, useLoader: false })));
    };
    CreateTeamName.defaultProps = {
        onBack: null
    };
    return CreateTeamName;
}(Component));
export default injectIntl(CreateTeamName);
